import React from 'react';

import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Radium, { StyleRoot } from 'radium';
import { fadeInRightBig } from 'react-animations';
import Img from 'react-image';

import buildingConcept from './../../assets/images/building-idilio-vistania-gs.png';
import sketch1 from './../../assets/images2/brochure/idilioVistania/sketch1.jpg';
import sketch2 from './../../assets/images2/brochure/idilioVistania/sketch2.jpg';
import './sass/index.sass';
import conceptAudio from './../../assets/audio/idilioVistaniaConcept.mp3';

const styles = {
  fadeInRightBig: {
    animation: 'x .5s',
    animationName: Radium.keyframes(fadeInRightBig, 'fadeInRightBig'),
  },
  fadeInRightBig2: {
    animation: 'x 1s',
    animationName: Radium.keyframes(fadeInRightBig, 'fadeInRightBig'),
  },
};

class ConceptIdilioVistania extends React.Component<any, any> {
  render() {
    return (
      <div className="cont-concept-project">
        <div className="con-text">
          <StyleRoot>
            <div style={styles.fadeInRightBig}>
              <div className="iconPlus" />
              <p>
                Existe un ámbito, un mundo, donde la creatividad, la imaginación y el amor por
                aquello que se hace crean una fuerza que trasciende lo obvio y alcanza la magia, la
                solución al misterio, dándole forma y belleza. Es precisamente desde ese mundo que
                Smart se complace en presentar, esta vez, el magnífico resultado del trabajo de
                Idilio VI, creador cuyo propósito constante es a cada instante algo inédito,
                disfrutando al mismo tiempo una nueva dimensión de auténtico confort en un marco de
                gozo estético, de belleza y calidad material, y su concreción y acierto funcional,
                una aproximación real a la excelencia.
              </p>
              <audio controls style={{ width: '100%', marginTop: '20px' }}>
                <source src={conceptAudio} type="audio/mpeg" />
                Tu navegador no soporta audio.
              </audio>
            </div>
          </StyleRoot>
        </div>
        <div className="vission imgIkiga" style={styles.fadeInRightBig}>
          <div className="brochure-sketches">
            <img src={sketch1} alt="sketch 1" />
{/*             <img src={sketch2} alt="sketch 2" /> */}
          </div>
        </div>
      </div>
    );
  }
}

export default ConceptIdilioVistania;
